<template>
	<v-card :height="$vuetify.breakpoint.smAndDown ? 800 : 770" class="plan free card-border">
		<v-card-text>
			<div class="text-center plan-header d-flex flex-column align-center justify-end">
				<v-img width="300" aspect-ratio="1" contain src="@/assets/images/mascot/Free.png"></v-img>

				<div class="fs--24 fw--500 mt-3">
					<span>Standard</span>
				</div>
				<p class="fieldFore--text fs--13 fw--500">Free for forever!</p>
			</div>

			<div class="features mb-3 mt-6">
				<div class="d-flex mb-2">
					<span class="fs--13 fw--500 fieldFore--text">
						<strong class="white--text">36</strong>
						Custom Sticker Slots
					</span>
				</div>
				<div class="d-flex mb-2">
					<span class="fs--13 fw--500 fieldFore--text">
						<strong class="white--text">6</strong>
						Reward Sticker Slots
					</span>
				</div>
				<div class="d-flex mb-2">
					<span class="fs--13 fw--500 fieldFore--text">
						<strong class="white--text">1</strong>
						Personal TTS Voice Model Slots
					</span>
				</div>
				<div class="d-flex mb-2">
					<span class="fs--13 fw--500 fieldFore--text">
						<strong class="white--text">3</strong>
						Personal TTS Sticker Slots
					</span>
				</div>
			</div>

			<div class="plan-footer">
				<v-btn v-if="currentPlan.tier === cardPlanLevel" class="plan-btn" color="gray" block depressed>
					Your Plan
				</v-btn>
			</div>
		</v-card-text>
	</v-card>
</template>
<script>
import { SubPlan } from '@/utils/constants.js';

export default {
	props: {
		subTier: {
			type: Number,
		},
		currentPlan: {
			type: Object,
		},
	},

	setup() {
		return {
			SubPlan,
			cardPlanLevel: SubPlan.FREE,
		};
	},
};
</script>
